import React, { useState, useMemo } from 'react';
import { Grid } from '@mui/material';
import TechActionStatChartBox from './TechActionStatChartBox';
import SalesActionStatTable from './SalesActionStatTable';
import TechActionStatWorkingBaseCard from './TechActionStatWorkingBaseCard';

function TechActionStatGrid({ 
  statEvents = [],
  actionEvents = [],
  holidayList = [],
  targetWorkMinutes, 
  baseWorkMinutes,
  startYear,
  startMonth,
  endYear,
  endMonth,
  userCount = 1, 
  onRowClick,
  dptList,
  usrList,
  filterLabels = { type: '', list: [] } // ✨ 부모(TechActionStat)에게서 주입받은 필터 가공 데이터 기본값 정의
}) {
  const [selectedAction, setSelectedAction] = useState('전체');

  const filteredDetailedEvents = useMemo(() => {
    if (selectedAction === '전체') return actionEvents;
    if (selectedAction === '미가동 시간') return [];
    return actionEvents.filter(row => row.actionName === selectedAction);
  }, [actionEvents, selectedAction]);

  return (
    <Grid container spacing={1.5}>
      {/* 💡 1. 베이스 카드를 최상단으로 이동 (가로 전체 너비 확보) 
      <Grid item xs={12}>
        <TechActionStatWorkingBaseCard
          statEvents={statEvents}
          holidayList={holidayList}
          targetWorkMinutes={targetWorkMinutes}
          baseWorkMinutes={baseWorkMinutes}
          startYear={startYear}
          startMonth={startMonth}
          endYear={endYear}
          endMonth={endMonth}
          userCount={userCount}
        />
      </Grid>
      */}
      
      {/* 💡 2. 차트 박스 영역에 필터 라벨 목록 데이터 주입 */}
      <Grid item xs={12}>
        <TechActionStatChartBox 
          statEvents={statEvents}
          selectedAction={selectedAction}
          setSelectedAction={setSelectedAction}
          baseWorkMinutes={baseWorkMinutes}
          userCount={userCount} 
          filterLabels={filterLabels} // ✨ [핵심 연결] 차트 컴포넌트가 X축을 구성할 수 있게 가공 리스트 전달
        />
      </Grid>

      {/* 💡 3. 테이블을 최하단에 배치 */}
      <Grid item xs={12}>
        <SalesActionStatTable filteredEvents={filteredDetailedEvents} onRowClick={onRowClick} />
      </Grid>
    </Grid>
  );
}

export default TechActionStatGrid;
